import { render, staticRenderFns } from "./ArticleLiveBlogHeader.vue?vue&type=template&id=4bc467de&scoped=true"
import script from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
export * from "./ArticleLiveBlogHeader.vue?vue&type=script&lang=ts"
import style0 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=0&id=4bc467de&prod&lang=scss&scoped=true"
import style1 from "./ArticleLiveBlogHeader.vue?vue&type=style&index=1&id=4bc467de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc467de",
  null
  
)

export default component.exports